import React, { useState, useEffect } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import './UserPanel.css';
import axios from './axiosConfig';

type DataItem = {
    id: number;
    name: string;
    type: string;
    url: string;
    host: string;
    port: number;
    username: string;
    password: string;
    database: string;
    accessToken: string;
    secure: boolean;
    status: boolean;
    lastChecked: string;
};

const DataSourcesList: React.FC = () => {
    const [mysqlSources, setMysqlSources] = useState<DataItem[]>([]);
    const [prometheusSources, setPrometheusSources] = useState<DataItem[]>([]);
    const [loadingMySQL, setLoadingMySQL] = useState<boolean>(true);
    const [loadingPrometheus, setLoadingPrometheus] = useState<boolean>(true);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [currentSource, setCurrentSource] = useState<DataItem | null>(null);

    useEffect(() => {
        const fetchMySQLDataSources = async () => {
            try {
                const response = await axios.get('/api/data-sources/mysql');
                setMysqlSources(response.data);
            } catch (error) {
                console.error('Failed to fetch MySQL data sources:', error);
            } finally {
                setLoadingMySQL(false);
            }
        };

        const fetchPrometheusDataSources = async () => {
            try {
                const response = await axios.get('/api/data-sources/prometheus');
                setPrometheusSources(response.data);
            } catch (error) {
                console.error('Failed to fetch Prometheus data sources:', error);
            } finally {
                setLoadingPrometheus(false);
            }
        };

        fetchMySQLDataSources();
        fetchPrometheusDataSources();
    }, []);

    const handleEdit = (source: DataItem) => {
        setCurrentSource(source);
        setShowModal(true);
    };

    const handleReconnect = async (source: DataItem) => {
        try {
            await axios.post(`/api/data-sources/${source.id}/reconnect`);
            if (source.type === 'MySQL') {
                const response = await axios.get('/api/data-sources/mysql');
                setMysqlSources(response.data);
            } else {
                const response = await axios.get('/api/data-sources/prometheus');
                setPrometheusSources(response.data);
            }
        } catch (error) {
            console.error('Failed to reconnect data source:', error);
        }
    };

    const handleSave = async () => {
        if (currentSource) {
            try {
                await axios.put(`/api/data-sources/${currentSource.id}`, currentSource);
                setShowModal(false);
                if (currentSource.type === 'MySQL') {
                    const response = await axios.get('/api/data-sources/mysql');
                    setMysqlSources(response.data);
                } else {
                    const response = await axios.get('/api/data-sources/prometheus');
                    setPrometheusSources(response.data);
                }
            } catch (error) {
                console.error('Failed to save data source:', error);
            }
        }
    };

    return (
        <div>
            <h2>Data Sources</h2>
            <Tabs defaultActiveKey="prometheus" id="data-source-tabs" className="mb-3 my-dark-tabs">
                <Tab eventKey="prometheus" title="Prometheus">
                    {loadingPrometheus ? (
                        <p>Loading Prometheus data sources...</p>
                    ) : prometheusSources.length > 0 ? (
                        <Table striped bordered hover size="sm" responsive variant="dark">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>URL</th>
                                <th>AccessToken</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {prometheusSources.map((source) => (
                                <tr key={source.id}>
                                    <td>{source.name}</td>
                                    <td>{source.url}</td>
                                    <td>{source.accessToken}</td>
                                    <td>{source.status ? "Connection Successful" : "Connection Failed"}</td>
                                    <td>
                                        <Button variant="warning" onClick={() => handleEdit(source)}>Edit</Button>{' '}
                                        <Button variant="primary" onClick={() => handleReconnect(source)}>Reconnect</Button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p>No Prometheus data sources found.</p>
                    )}
                </Tab>
                {/*<Tab eventKey="mysql" title="MySQL">*/}
                {/*    {loadingMySQL ? (*/}
                {/*        <p>Loading MySQL data sources...</p>*/}
                {/*    ) : mysqlSources.length > 0 ? (*/}
                {/*        <Table striped bordered hover size="sm" responsive variant="dark">*/}
                {/*            <thead>*/}
                {/*            <tr>*/}
                {/*                <th>Name</th>*/}
                {/*                <th>Host</th>*/}
                {/*                <th>Port</th>*/}
                {/*                <th>Database</th>*/}
                {/*                <th>Status</th>*/}
                {/*                <th>Actions</th>*/}
                {/*            </tr>*/}
                {/*            </thead>*/}
                {/*            <tbody>*/}
                {/*            {mysqlSources.map((source) => (*/}
                {/*                <tr key={source.id}>*/}
                {/*                    <td>{source.name}</td>*/}
                {/*                    <td>{source.host}</td>*/}
                {/*                    <td>{source.port}</td>*/}
                {/*                    <td>{source.database}</td>*/}
                {/*                    <td>{source.status ? "Connection Successful" : "Connection Failed"}</td>*/}
                {/*                    <td>*/}
                {/*                        <Button variant="warning" onClick={() => handleEdit(source)}>Edit</Button>{' '}*/}
                {/*                        <Button variant="primary" onClick={() => handleReconnect(source)}>Reconnect</Button>*/}
                {/*                    </td>*/}
                {/*                </tr>*/}
                {/*            ))}*/}
                {/*            </tbody>*/}
                {/*        </Table>*/}
                {/*    ) : (*/}
                {/*        <p>No MySQL data sources found.</p>*/}
                {/*    )}*/}
                {/*</Tab>*/}
            </Tabs>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Data Source</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {currentSource && (
                        <Form>
                            <Form.Group controlId="formName">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentSource.name}
                                    onChange={(e) => setCurrentSource({ ...currentSource, name: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formType">
                                <Form.Label>Type</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentSource.type}
                                    onChange={(e) => setCurrentSource({ ...currentSource, type: e.target.value })}
                                    disabled
                                />
                            </Form.Group>
                            <Form.Group controlId="formURL">
                                <Form.Label>URL</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentSource.url}
                                    onChange={(e) => setCurrentSource({ ...currentSource, url: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formHost">
                                <Form.Label>Host</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentSource.host}
                                    onChange={(e) => setCurrentSource({ ...currentSource, host: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formPort">
                                <Form.Label>Port</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={currentSource.port}
                                    onChange={(e) => setCurrentSource({ ...currentSource, port: parseInt(e.target.value) })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formUsername">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentSource.username}
                                    onChange={(e) => setCurrentSource({ ...currentSource, username: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={currentSource.password}
                                    onChange={(e) => setCurrentSource({ ...currentSource, password: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formDatabase">
                                <Form.Label>Database</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentSource.database}
                                    onChange={(e) => setCurrentSource({ ...currentSource, database: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formAccessToken">
                                <Form.Label>Access Token</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentSource.accessToken}
                                    onChange={(e) => setCurrentSource({ ...currentSource, accessToken: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formSecure">
                                <Form.Check
                                    type="checkbox"
                                    label="Use HTTPS"
                                    checked={currentSource.secure}
                                    onChange={(e) => setCurrentSource({ ...currentSource, secure: e.target.checked })}
                                />
                            </Form.Group>
                        </Form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DataSourcesList;
